import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.function.name.js";
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "activity-view-dialog"
};
var _hoisted_2 = {
  class: "body-left"
};
var _hoisted_3 = ["src"];
var _hoisted_4 = {
  class: "body-right"
};
var _hoisted_5 = {
  class: "body-right_title"
};
var _hoisted_6 = ["src"];
var _hoisted_7 = {
  class: "title"
};
var _hoisted_8 = {
  class: "time"
};
var _hoisted_9 = {
  class: "body-right_context"
};
var _hoisted_10 = {
  class: "context_title"
};
var _hoisted_11 = {
  class: "context_content"
};
var _hoisted_12 = ["src"];
var _hoisted_13 = {
  class: "like-count"
};
var _hoisted_14 = {
  class: "circle-box"
};
var _hoisted_15 = ["src"];
var _hoisted_16 = ["src"];
import { MessagePlugin } from 'tdesign-vue-next';
import { ref, onMounted, watch } from 'vue';
import { useModel } from '@/hooks/useModel';
import { switchPage, giveLike } from '@/api/personalHomepage';
export default {
  __name: 'AlbumViewDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    pictureId: {
      type: String,
      default: ''
    },
    IdPeople: {
      type: String,
      default: ''
    },
    clickLeftValue: {
      type: String,
      default: ''
    }
  },
  emits: ['update:visible'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var emit = __emit;
    var visibleS = useModel({
      props: props,
      emit: emit,
      key: 'visible'
    });
    var redStar = require('@/assets/home/red-star.svg');
    var blackStar = require('@/assets/home/star.svg');
    var rightCircle = require('@/assets/home/right-circle.svg');
    var leftCircle = require('@/assets/home/left-circle.svg');
    var baseImg = require('@/assets/home/baseImg.svg');
    var list = ref({});
    var handleClose = function handleClose() {
      emit('update:visible', false);
    };
    // 点赞
    var handleLikeClick = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(val) {
        var id, isLike, opType, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              id = val.id, isLike = val.isLike;
              _context.p = 1;
              opType = isLike === 0 ? 1 : 0;
              list.value.isLike = isLike === 0 ? 1 : 0;
              list.value.likeCount = isLike === 0 ? list.value.likeCount - 1 : list.value.likeCount + 1;
              _context.n = 2;
              return giveLike(id, 1, opType);
            case 2:
              emit('updateStar');
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              MessagePlugin.error('请求失败，请重试');
            case 4:
              return _context.a(2);
          }
        }, _callee, null, [[1, 3]]);
      }));
      return function handleLikeClick(_x) {
        return _ref2.apply(this, arguments);
      };
    }();
    // 左右边切换
    var changeShowImg = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(num) {
        var id,
          query,
          _yield$switchPage,
          data,
          _args2 = arguments,
          _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              id = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : props.pictureId;
              query = {
                id: id,
                type: num,
                userId: props.IdPeople,
                viewRadius: props.clickLeftValue
              };
              _context2.p = 1;
              _context2.n = 2;
              return switchPage(query);
            case 2:
              _yield$switchPage = _context2.v;
              data = _yield$switchPage.data;
              if (data.data) {
                list.value = data.data;
              } else {
                MessagePlugin.error('没有更多了');
              }
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t2 = _context2.v;
              MessagePlugin.error('请求失败，请重试');
            case 4:
              return _context2.a(2);
          }
        }, _callee2, null, [[1, 3]]);
      }));
      return function changeShowImg(_x2) {
        return _ref3.apply(this, arguments);
      };
    }();
    watch(function () {
      return props.visible;
    }, /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(newValue) {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (!newValue) {
                _context3.n = 1;
                break;
              }
              _context3.n = 1;
              return changeShowImg('2');
            case 1:
              return _context3.a(2);
          }
        }, _callee3);
      }));
      return function (_x3) {
        return _ref4.apply(this, arguments);
      };
    }());
    return function (_ctx, _cache) {
      var _component_t_dialog = _resolveComponent("t-dialog");
      return _openBlock(), _createBlock(_component_t_dialog, {
        visible: _unref(visibleS),
        "onUpdate:visible": _cache[3] || (_cache[3] = function ($event) {
          return _isRef(visibleS) ? visibleS.value = $event : null;
        }),
        attach: "body",
        placement: "center",
        header: "作品详情",
        width: "1114px",
        footer: false,
        "on-close": handleClose,
        class: "album-view-dialog"
      }, {
        body: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
            src: list.value.cover,
            alt: ""
          }, null, 8, _hoisted_3)]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
            src: list.value.avatar || _unref(baseImg),
            alt: ""
          }, null, 8, _hoisted_6), _createElementVNode("div", _hoisted_7, [_createElementVNode("span", null, _toDisplayString(list.value.name), 1), _createElementVNode("span", _hoisted_8, _toDisplayString(list.value.time), 1)])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, _toDisplayString(list.value.title), 1), _createElementVNode("div", _hoisted_11, _toDisplayString(list.value.remark), 1)]), _createElementVNode("div", {
            class: "body-right_like",
            onClick: _cache[0] || (_cache[0] = function ($event) {
              return handleLikeClick(list.value);
            })
          }, [_createElementVNode("img", {
            src: list.value.isLike === 0 ? _unref(redStar) : _unref(blackStar),
            class: "icon_love",
            alt: ""
          }, null, 8, _hoisted_12), _createElementVNode("span", _hoisted_13, _toDisplayString(list.value.likeCount), 1)])])]), _createElementVNode("div", _hoisted_14, [_createElementVNode("img", {
            src: _unref(leftCircle),
            onClick: _cache[1] || (_cache[1] = function ($event) {
              return changeShowImg('0', list.value.id);
            }),
            alt: ""
          }, null, 8, _hoisted_15), _createElementVNode("img", {
            src: _unref(rightCircle),
            onClick: _cache[2] || (_cache[2] = function ($event) {
              return changeShowImg('1', list.value.id);
            }),
            alt: ""
          }, null, 8, _hoisted_16)])];
        }),
        _: 1
      }, 8, ["visible"]);
    };
  }
};